import getLocal from '@/app/utils/getLocal';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import classNames from 'classnames';
import React from 'react';
import EfImg from 'elem/ui/ef-img';
import './index.scss';
import { langText } from './langText';

export interface EfCardCartItemProps {
    /**
     * 产品 tag
     */
    tag?: string;
    /**
     * 产品 productId
     */
    productId?: string;
    /**
     * 产品 variantId
     */
    variantId?: string;
    /**
     * 默认购买数量
     */
    quantity?: number;
    /**
     * 库存
     */
    inventory?: number;
    /**
     * 所有分辨率展示的资源链接
     */
    img?: string;
    /**
     * tag
     */
    tag?: string;
    /**
     * 主标题
     */
    title: string;
    /**
     * subtitle描述文案
     */
    subtitle?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 产品原始价格
     */
    originalPrice?: number;
    /**
     * 产品折后价格
     */
    discountPrice?: number;
    /**
     * btnCartText
     */
    btnCartText?: string;
}

export interface EfCardCartListsProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * gtm list name
     */
    list_name?: string;
    /**
     * 商品列表
     */
    items?: EfCardCartItemProps[];
    /**
     * callbackCart
     */
    callbackCart?: any;
}

/**
 * 维护: kalkin
 *
 * 商品卡片列表 - 添加购物车
 */
const EfCardCartLists: React.FC<EfCardCartListsProps> = ({ items, className, list_name, callbackCart }) => {
    const prefixCls = `ef-card-cart-lists`;
    const prefix = `${prefixCls}-`;
    const { locale } = getLocal();
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const i18n = langText[locale] || langText['jp'];

    return (
        <div className={classes}>
            <ul className={`${prefix}cards`}>
                {items?.map((item: EfCardCartItemProps, k: number) => (
                    <li className={`${prefix}card${items?.some((list: EfCardCartItemProps) => list?.tag) ? ' has-tag' : ''}`} key={k}>
                        {item?.tag && <span className={`${prefix}card-tag`}>{item?.tag}</span>}
                        <div className={`${prefix}card-img`}>
                            <EfImg pc={item.img} />
                        </div>
                        <div className={`${prefix}card-info`}>
                            {item?.label && <p className={`${prefix}info-label`}>{item?.label}</p>}
                            {item?.title && <p className={`${prefix}info-title`}>{item?.title}</p>}
                            {item?.subtitle && <p className={`${prefix}info-subtitle`}>{item?.subtitle}</p>}
                            {item?.desc && <p className={`${prefix}info-desc`}>{item?.desc}</p>}
                        </div>
                        <div className={`${prefix}card-footer`}>
                            {item?.discountPrice && (
                                <div className={`${prefix}card-discount-price`}>
                                    {FormatMoneyLocal(item?.discountPrice, locale)}
                                    {<span className={`${prefix}card-price-suffix`}>{i18n.suffix}</span>}
                                </div>
                            )}
                            {item?.originalPrice && item?.originalPrice !== item?.discountPrice && (
                                <div className={`${prefix}card-original-price`}>
                                    {<span className={`${prefix}card-price-prefix`}>{i18n.prefix}</span>}
                                    {FormatMoneyLocal(item?.originalPrice, locale)}
                                    {<span className={`${prefix}card-price-suffix`}>{i18n.suffix}</span>}
                                </div>
                            )}
                            <button className={`${prefix}card-add-cart${item?.inventory <= 0 ? ' disable' : ''}`} onClick={() => callbackCart(item, list_name)}>
                                {item?.btnCartText || i18n.cart}
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EfCardCartLists;
